// import React, { useEffect } from 'react'
// import Header from './../pages/Dashboard/sidebar/Header';
// import Sidebar from '../pages/Dashboard/sidebar/Sidebar';
// import {Toaster}  from 'react-hot-toast';
// import { image2svg, numberCounter } from '../UtilsComponent/UtilFunctions'; 
// const Wrapper = (props) => {
 
//   return (
//     <>
//       <Toaster
//                 position="top-right"
//                 reverseOrder={false}
//             />
//             <Sidebar obj={props.obj}></Sidebar>
//         <main className={"main__wapper"}> 
//             <Header headerTitle={props.headerTitle}></Header>
            
//             {props.children}

            

//         </main>
//     </>
//   )
// }

// export default Wrapper; 
  

import React, { useState, useEffect } from "react";
import Header from "./../pages/Dashboard/sidebar/Header";
import Sidebar from "../pages/Dashboard/sidebar/Sidebar";
import { Toaster } from "react-hot-toast";

const SIDEBAR_W = 240;
const MOBILE_BP = 768;

const Wrapper = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BP);
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > MOBILE_BP);

  // Re-evaluate when the screen is resized or rotated
  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth <= MOBILE_BP;
      setIsMobile((prev) => {
        if (prev !== mobile) setIsSidebarOpen(!mobile); // closed on mobile, open on desktop
        return mobile;
      });
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen((o) => !o);
  const closeSidebar = () => setIsSidebarOpen(false);

  // Desktop: push content. Mobile: sidebar overlays, so no offset.
  const mainStyle = {
    marginLeft: !isMobile && isSidebarOpen ? SIDEBAR_W : 0,
    paddingLeft: 0,
    width: "auto",
    maxWidth: "none",
    transition: "margin-left 0.25s ease",
  };

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <Sidebar
        obj={props.obj}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
        onClose={closeSidebar}
      />

      {/* Dark backdrop, mobile only */}
      {isMobile && isSidebarOpen && (
        <div
          onClick={closeSidebar}
          style={{
            position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
            zIndex: 150,
          }}
        />
      )}

      <main className="main__wapper" style={mainStyle}>
        <Header headerTitle={props.headerTitle} toggleSidebar={toggleSidebar} />
        {props.children}
      </main>
    </>
  );
};

export default Wrapper;